import { handleException } from 'actions/exceptions';
import { ApiService } from 'services';

export const GET_FORM_DETAILS_REQUEST = 'GET_FORM_DETAILS_REQUEST';
export const GET_FORM_DETAILS_SUCCESS = 'GET_FORM_DETAILS_SUCCESS';
export const GET_FORM_DETAILS_FAILURE = 'GET_FORM_DETAILS_FAILURE';
export const GET_FORM_DETAILS_CLEAR = 'GET_FORM_DETAILS_CLEAR';

function request(formId, rowId) {
  return {
    type: GET_FORM_DETAILS_REQUEST,
    formId,
    rowId
  };
}

function receive(formDetails, formId, rowId) {
  return {
    type: GET_FORM_DETAILS_SUCCESS,
    formId,
    rowId,
    formDetails,
    getFormDetailsDataError: null
  };
}

function reject(formId, rowId, getFormDetailsError) {
  return {
    type: GET_FORM_DETAILS_FAILURE,
    formId,
    rowId,
    getFormDetailsError
  };
}

function clear(formId, rowId) {
  return {
    type: GET_FORM_DETAILS_CLEAR,
    formId,
    rowId
  };
}

export function getFormDetails(formId, rowId) {
  return (dispatch) => {
    dispatch(request(formId, rowId));

    const promise = () => ApiService
      .getFormDetails(formId)
      .then((response) => {
        dispatch(receive(response.data, formId, rowId));
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          if (error.response) {
            error.response.data = { code: error.response.status, message: 'Sorry, we were unable to retrieve your form at this time, please try again later' };
            dispatch(reject(formId, rowId, error.response.data));
          }
          dispatch(handleException(error, null, true));
        }
      });
    return promise();
  };
}

export function clearFormDetails(formId, rowId) {
  return (dispatch) => {
    dispatch(clear(formId, rowId));
  };
}
